export default [
  {
    answer: 'airasia ride covers the following locations:<ul><li>Klang Valley</li><li>Langkawi</li><li>Penang</li><li>Johor Bahru</li><li>Melaka</li><li>Seremban</li><li>Alor Star</li><li>Kuala Terengganu</li><li>Kota Bharu</li><li>Ipoh</li><li>Kota Kinabalu</li><li>Tawau</li><li>Sandakan</li><li>Kuching</li></ul>',
    question: 'What areas do airasia ride and airasia food cover?'
  },
  {
    question:'Does airasia help me obtain my PSV licence and e-hailing permits?',
    answer:'At the moment, only for Klang Valley drivers, but we’re working on providing this benefit for all our drivers nationwide.'
  },
  {
    question:'How old should my car be if I want to be an airasia ride driver?',
    answer:'Your car should not be more than 10 years old.'
  },
  {
    question:'Do airasia riders and drivers have insurance coverage? ',
    answer:'Yes, all airasia riders and drivers are provided with insurance coverage. Terms and conditions apply. '
  },
  {
    question:'What is independent driver and independent rider?',
    answer:'Independent drivers and riders work on a part-time basis, and they may choose their preferred job requests. '
  },
]
